// extracted by mini-css-extract-plugin
export default {"track":"TravelToggle_track__JQrMA","btn":"TravelToggle_btn__Q9pas","car":"TravelToggle_car__4a9nu","foot":"TravelToggle_foot__pkyrL","on":"TravelToggle_on__uzgNU"};